class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");
    var _subscribed = false;
    try { _subscribed = localStorage.getItem("mz_np_subscribed") === "1"; } catch (e) {}

    // Reliable submit: let the native {% form 'customer' %} post into a hidden iframe.
    // We deliberately do NOT preventDefault/fetch — Shopify's bot-protection script
    // attaches a required CAPTCHA token on the native submit event; hijacking it drops
    // the token and mangles the submission (email/tags lost). Targeting a hidden iframe
    // keeps the submit fully native while the page never reloads → instant success.
    this.form = this.popup.querySelector("form.newsletter-form");
    this.frame = this.popup.querySelector('iframe[name="mzNpFrame"]');
    if (this.form && this.frame) {
      var submitted = false;
      var errTimer = null;
      const submitBtn = this.form.querySelector('[type="submit"]');

      this.form.addEventListener("submit", () => {
        submitted = true; // fires only after the browser's required/email validation passes
        if (submitBtn) submitBtn.setAttribute("disabled", "disabled");
        if (errTimer) clearTimeout(errTimer);
        errTimer = setTimeout(() => {
          if (submitBtn) submitBtn.removeAttribute("disabled");
          submitted = false;
        }, 10000);
      });

      this.frame.addEventListener("load", () => {
        if (!submitted) return; // ignore the iframe's initial empty load
        if (errTimer) clearTimeout(errTimer);
        try { localStorage.setItem("mz_np_subscribed", "1"); } catch (e) {}
        this.renderSuccess();
      });
    }

    if (this.hasSubscription || this.cookie || _subscribed) return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn.addEventListener("click", () => {
      this.popup.classList.add("hidden");
      this.setCookie("hideNotificationPopup", "true", 7);
    });
  }

  renderSuccess() {
    const content = this.popup.querySelector(".newsletter__content");
    if (content) {
      content.innerHTML =
        '<div style="text-align:center;padding:6px 4px">' +
        '<h2 style="font-family:var(--font-heading-family,inherit);font-weight:var(--font-heading-weight,700);font-size:2rem;line-height:1.15;margin:0 0 10px">Success!</h2>' +
        '<p style="margin:0;font-size:1.05rem;line-height:1.5">Check your inbox for the free gift! 🎁</p>' +
        "</div>";
    }
    this.popup.classList.remove("hidden");
    this.popup.classList.add("wt-popup-fade-in");
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);
